const Location = () => {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="py-20 px-6 border-b border-stone-800 bg-stone-900/40"
    >
      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-8 items-center">
        <div className="space-y-4">
          <span className="mono-tag text-xs uppercase tracking-widest text-amber-500">
            Jurisdiction &amp; Reach
          </span>
          <h3 className="text-2xl font-bold text-stone-100 display-serif">
            Henderson, Las Vegas &amp; Abroad
          </h3>
          <p className="text-sm text-stone-400 leading-relaxed">
            Headquartered in the greater Henderson and Las Vegas area of Nevada, serving
            participating individuals and enterprise delegates worldwide through private
            communication and on-site intensive mentorship.
          </p>
          <div className="text-xs text-stone-300 font-mono pt-2">
            Operating Hours: Tailored per member cohort · Average 6+ hrs daily engagement
          </div>
        </div>
        <div
          data-testid="location-map"
          className="aspect-[16/9] rounded-xl border border-stone-800 overflow-hidden relative bg-stone-900"
        >
          <iframe
            title="Greater Henderson and Las Vegas, Nevada area map"
            src="https://www.openstreetmap.org/export/embed.html?bbox=-115.30%2C35.85%2C-114.80%2C36.30&layer=mapnik&marker=36.0395%2C-114.9817"
            className="absolute inset-0 w-full h-full grayscale invert-[0.92] hue-rotate-180 contrast-[0.85]"
            loading="lazy"
          ></iframe>
          <div className="absolute bottom-3 left-3 mono-tag text-[10px] text-amber-400 bg-stone-950/90 px-2 py-1 rounded border border-stone-800">
            NEVADA HEADQUARTERS &amp; GLOBAL CHANNELS
          </div>
        </div>
      </div>
    </section>
  );
};

export default Location;
